import { FileSearchOutlined } from "@ant-design/icons"
import { ApiLogs } from "."

export const API_LOG_ROUTES = [
  {
    path: "/api-logs/:entityID?",
    component: ApiLogs
  }
]

export const API_LOG_NAVIGATION = [
  {
    title: "Api Logs",
    path: "/api-logs",
    submenu: false,
    icon: <FileSearchOutlined />,
    iconActive: <FileSearchOutlined />
  }
]
